import React from 'react';
import { PanelLayout } from '../../../layout/Panel/Panel';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';
import IconComponent from '../../../shared/IconComponents/IconComponent';
import { FlexBetween } from '../../../layout/FlexBetween/FlexBetween';
import { CleanButton } from '../../../ui/CleanButton';
import { TextCustom } from '../../../ui/TextCustom';
import { TColorRole } from '../../../../types/types';
import { FlexCenter } from '../../../layout/FlexCenter/FlexCenter';
import { Spacing } from '../../../layout/Spacing/Spacing';

interface IGreySectionsProps {
    children?: React.ReactNode;
    title: string;
    func?: () => void;
    closeSection: boolean;
    hasArrow?: boolean;
    color?: TColorRole;
    isRelative?: boolean;
    arrowSize?: number;
    showTitle?: boolean;
    removeSpacing?: boolean;
}

export const GreySections: React.FC<IGreySectionsProps> = ({removeSpacing = false, showTitle = false, arrowSize = 1.4, isRelative = false, color = "grey-superLight", children, title, func, closeSection, hasArrow = true }) => {
    
    const arrow = <CleanButton stretch = {showTitle ? false : true}  func={func}>
                        <Spacing paddingSpacing="m" marginSpacing="none">
                            <IconComponent size={arrowSize} iconName={closeSection ? 'Arrow_up' : 'Arrow_down'} />
                        </Spacing>
                    </CleanButton>
    
    return (
        <div style={{width: '100%'}}>
            <PanelLayout stretch color={color} hasShadow={false} borderIntensity={0} isRelative={isRelative}>
                <SpacingCustom paddingLeft={removeSpacing ? 0 : 1} paddingTop={removeSpacing ? 0 : 1} paddingRight={removeSpacing ? 0 : 1} paddingBottom={removeSpacing ? 0 : 1}>
                    <SpacingCustom marginBottom={closeSection ? 1 : 0}>
                        {
                            showTitle
                            ?
                            <FlexBetween>
                                <TextCustom weight={500} color="grey-dark" size={1.2}>
                                    {title}
                                </TextCustom>
                        
                                { hasArrow && arrow }
                            </FlexBetween>
                            :
                            <PanelLayout stretch color={"grey-superLight"} hasShadow={false} borderIntensity={0} isRelative={isRelative}>
                                <FlexCenter>
                                { hasArrow && arrow }
                                </FlexCenter>
                            </PanelLayout>
                        }
                    </SpacingCustom>
                    {children}
                </SpacingCustom>
            </PanelLayout>
        </div>
    );
};
